import { lazy } from 'react'

export default {
    path: '/report/dettaglio-consuntivi',
    title: 'Dettaglio consuntivi',
    authenticated: true,
    component: lazy(() => import('./filter'))
}